import { CustomType, CustomTypeFilters } from "../../../api/CustomTypes/CustomTypes";
import { CustomTypeEntityTypeOptions } from "../../../api/CustomTypes/CustomTypesBase";
import { DefinedPropertyObject } from "../../../api/GenericTypes";
import { GenericVirtualizedSelectFormField } from "../../../common/formfields/GenericVirtualizedSelectFormField/GenericVirtualizedSelectFormField";
import { ToggleFormField } from "../../../common/formfields/ToggleFormField";
import { EntityFilterSideBar } from "../../../common/sidebar/filtersidebar/EntityFilterBar";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import { CustomTypeEntityTypeOptionToIcon } from "../CustomTypeRenderUtils";
import {
  CombinedModificationRecordEntityDefaultFormValues,
  combinedModificationRecordEntityFiltersToForm,
  combinedModificationRecordEntityFormToFilters,
  ICombinedModificationRecordEntityForm,
} from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterFormModels";
import { CombinedModificationRecordEntityFilterForm } from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterForm";
import { defaultCustomTypesFilters } from "./CustomTypesTable";

export interface CustomTypeFilterForm extends ICombinedModificationRecordEntityForm {
  entityType?: CustomType["entityType"][] | undefined | null;
  excludeDisabled?: boolean | null;
}
const defaultValues: DefinedPropertyObject<CustomTypeFilterForm> = {
  entityType: null,
  excludeDisabled: true,
  ...CombinedModificationRecordEntityDefaultFormValues,
};
export const customTypesFormToFilters = (form: CustomTypeFilterForm): CustomTypeFilters => {
  let filters: CustomTypeFilters = {
    ...combinedModificationRecordEntityFormToFilters(form),
  };
  filters.entityTypes = Array.isArray(form.entityType) && form.entityType.length > 0 ? form.entityType : null;
  filters.excludeDisabled = form.excludeDisabled;
  return filters;
};

/**
 * Converts CustomTypeFilters to CustomTypeFilterForm
 * @param filters CustomTypeFilters
 * @returns CustomTypeFilterForm
 * @author @CorradoSurmanowicz
 */
export const customTypesFiltersToForm = (filters: CustomTypeFilters): CustomTypeFilterForm => {
  return {
    entityType: filters.entityTypes || null,
    excludeDisabled: filters.excludeDisabled ?? true,
    ...combinedModificationRecordEntityFiltersToForm(filters),
  };
};

export const CustomTypesFilterBar = ({
  initialValues,
  dispatchTabStore,
  onFormChange,
  tabsLoading,
  currentTab,
  hideEntityTypeFilter = false,
}: TabStoreFilterSidebarProps<CustomType, CustomTypeFilterForm, CustomTypeFilters> & {
  hideEntityTypeFilter?: boolean;
}) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultCustomTypesFilters}
      formToFilters={customTypesFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          {!currentTab?.includes("entity-type") && !hideEntityTypeFilter && (
            <GenericVirtualizedSelectFormField
              id="entityType"
              label="Entity type"
              control={control}
              items={CustomTypeEntityTypeOptions.map((v) => v)}
              placeholder="Select entity type..."
              onRowStartRenderer={(row) => (
                <CustomTypeEntityTypeOptionToIcon entityType={row} color={"var(--primary)"} />
              )}
              isMulti
            />
          )}
          <ToggleFormField id="excludeDisabled" label="Exclude disabled" control={control} horizontal />

          <CombinedModificationRecordEntityFilterForm
            control={control}
            currentTab={currentTab}
            initialValues={initialValues}
          />
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
